<template>
  <div class="app_detail_container">
    <PageTitle
      :title="title"
      :showFileBtn="true"
      backPath="AppEvection"
      :menuArgs="menuArgs"
      @clickFileBtn="clickFileBtn"
    />
    <div class="app_menu_main">
      <div
        v-if="
          String($store.state.userInfo.authority).includes('领导审核') ||
            String($store.state.userInfo.authority).includes('财务审核')
        "
      >
        <EvectionPrint ref="EvectionPrintRef" :printData="form" />
      </div>
      <div v-else>
        <PageDetailDivider ref="PageDetailDividerRef" title="主表信息" />
        <div class="app_menu_main_form">
          <el-form :rules="rules" :model="form">
            <el-form-item label="公司" prop="company">
              <el-input placeholder="关联获取" readonly v-model="form.company" />
            </el-form-item>
            <el-form-item label="报销日期" prop="r_date">
              <el-input placeholder="关联获取" v-date readonly v-model="form.r_date" />
            </el-form-item>
            <el-form-item label="出差人" prop="users_names">
              <el-input placeholder="关联获取" readonly v-model="form.users_names" />
            </el-form-item>
            <el-form-item label="出差开始日期" prop="e_begin_date">
              <el-input placeholder="关联获取" v-date readonly v-model="form.e_begin_date" />
            </el-form-item>
            <el-form-item label="出差结束日期" prop="e_end_date">
              <el-input placeholder="关联获取" v-date readonly v-model="form.e_end_date" />
            </el-form-item>
            <el-form-item label="出差天数" prop="e_day_count">
              <el-input placeholder="关联获取" readonly v-model="form.e_day_count" />
            </el-form-item>
            <el-form-item label="出差事由" prop="subject_matter">
              <el-input type="textarea" :rows="5" placeholder="关联获取" readonly v-model="form.subject_matter" />
            </el-form-item>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item label="办公费-发票数量" prop="office_count">
                  <el-input placeholder="关联获取" readonly v-model="form.office_count" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="办公费(元)" prop="office_expenses">
                  <el-input placeholder="关联获取" v-appmoney:2="showMoney" readonly v-model="form.office_expenses" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item label="餐费-发票数量" prop="meal_count">
                  <el-input placeholder="关联获取" readonly v-model="form.meal_count" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="餐费(元)" prop="meal_expenses">
                  <el-input placeholder="关联获取" v-appmoney:2="showMoney" readonly v-model="form.meal_expenses" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item label="交通费-发票数量" prop="traffic_count">
                  <el-input placeholder="关联获取" readonly v-model="form.traffic_count" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="交通费(元)" prop="traffic_expenses">
                  <el-input placeholder="关联获取" v-appmoney:2="showMoney" readonly v-model="form.traffic_expenses" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item label="邮电费-发票数量" prop="post_count">
                  <el-input placeholder="关联获取" readonly v-model="form.post_count" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="邮电费(元)" prop="post_expenses">
                  <el-input placeholder="关联获取" v-appmoney:2="showMoney" readonly v-model="form.post_expenses" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item label="检定费-发票数量" prop="check_count">
                  <el-input placeholder="关联获取" readonly v-model="form.check_count" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="检定费(元)" prop="check_expenses">
                  <el-input placeholder="关联获取" v-appmoney:2="showMoney" readonly v-model="form.check_expenses" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item label="其他-发票数量" prop="other_count">
                  <el-input placeholder="关联获取" readonly v-model="form.other_count" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="其他费用(元)" prop="other_expenses">
                  <el-input placeholder="关联获取" v-appmoney:2="showMoney" readonly v-model="form.other_expenses" />
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-form-item label="误餐补助(元)" prop="meal_allowance">
              <el-input placeholder="关联获取" v-appmoney:2="showMoney" readonly v-model="form.meal_allowance" />
            </el-form-item>
            <el-form-item label="公杂费(元)" prop="miscellaneous_expenses">
              <el-input
                placeholder="关联获取"
                v-appmoney:2="showMoney"
                readonly
                v-model="form.miscellaneous_expenses"
              />
            </el-form-item> -->
            <el-form-item label="明细费用(元)" prop="detail_expenses">
              <el-input placeholder="关联获取" v-appmoney:2="showMoney" readonly v-model="form.detail_expenses" />
            </el-form-item>
            <el-form-item label="合计金额(元)" prop="total_expenses">
              <el-input placeholder="关联获取" v-appmoney:2="showMoney" readonly v-model="form.total_expenses" />
            </el-form-item>
          </el-form>
        </div>
        <PageDetailDivider title="明细信息" />

        <div class="no-detail-data" v-if="form.detailList.length === 0">
          - 没有明细数据 -
        </div>

        <div class="bottom-detail">
          <div class="detail" v-for="(item, index) of form.detailList" :key="index">
            <div class="detail-item">
              <span>日期：</span>
              {{ ykDateFormat('yyyy-MM-dd', item.begin_date) }}
            </div>
            <!-- <div class="detail-item">
            <span>截止日期：</span>
            {{ ykDateFormat('yyyy-MM-dd', item.end_date) }}
          </div> -->
            <div class="detail-item db-detail-item">
              <span>出发地：</span>
              {{ item.begin_address }}
            </div>
            <div class="detail-item db-detail-item">
              <span>目的地：</span>
              {{ item.end_address }}
            </div>
            <div class="detail-item">
              <span>交通类别: </span>
              {{ item.traffic_type }}
            </div>
            <div class="detail-item">
              <span>交通票据数: </span>
              {{ item.traffic_invoice_count }}
            </div>
            <div class="detail-item">
              <span>交通含税金额(元): </span>
              {{ $utils.commafy(item.traffic_invoice_amount, { digits: 2 }) }}
            </div>
            <div class="detail-item">
              <span>住宿费票据数: </span>
              {{ item.stay_invoice_count }}
            </div>
            <div class="detail-item">
              <span>住宿费含税金额(元): </span>
              {{ $utils.commafy(item.stay_invoice_amount, { digits: 2 }) }}
            </div>
            <div class="detail-item">
              <span>天数: </span>
              {{ item.travel_days }}
            </div>
            <div class="detail-item">
              <span>误餐补助标准/天: </span>
              {{ item.meal_allowance }}
            </div>
            <div class="detail-item">
              <span>公杂费标准/天: </span>
              {{ item.miscellaneous_expenses }}
            </div>
            <div class="detail-item">
              <span>备注: </span>
              {{ item.memo }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <PageDetailBtns ref="PageDetailBtnsRef" menuPath="Evection" :parentData="this" @handleClick="handleClickBtn" />
    <!-- 附件 -->
    <PageDetailFile ref="PageDetailFileRef" :ID="id" vuePath="Evection" />
    <!-- 财务审批 -->
    <FinancialReviewModalVue ref="FinancialReviewModalVueRef" @sureHandler="sureFinancialReview" />
    <!-- 确认dialog -->
    <ConfirmModal ref="ConfirmModalRef" @confirm="sureConfirm" />
  </div>
</template>
<script>
import PageTitle from '@/components/app/PageHeader.vue'
import PageDetailBtns from '@/components/app/PageDetailBtns.vue'
import PageDetailDivider from '@/components/app/PageDetailDivider.vue'
import PageDetailFile from '@/components/app/PageDetailFile.vue'
import FinancialReviewModalVue from '@/components/common/ReviewModal.vue'
import ConfirmModal from '@/components/app/ConfirmModal.vue'
import EvectionPrint from '@/components/print/Evection.vue'

export default {
  components: {
    PageTitle,
    PageDetailBtns,
    PageDetailDivider,
    PageDetailFile,
    FinancialReviewModalVue,
    ConfirmModal,
    EvectionPrint
  },
  data() {
    return {
      id: -1,
      title: '差旅费报销单明细',
      formVisible: false,
      // 表单
      form: {
        detailList: [],
        id: 0,
        creator_id: 0,
        creator: '',
        createTime: '',
        manager_review: false,
        document_status: 0,
        r_date: '',
        users_id: 0,
        users_names: '',
        subject_matter: '',
        company: '',
        e_begin_date: '',
        e_end_date: '',
        e_day_count: '',
        office_count: 0,
        office_expenses: 0,
        meal_count: 0,
        meal_expenses: 0,
        traffic_count: 0,
        traffic_expenses: 0,
        post_count: 0,
        post_expenses: 0,
        check_count: 0,
        check_expenses: 0,
        other_count: 0,
        other_expenses: 0,
        last_modify_time: '',
        meal_allowance: 0,
        miscellaneous_expenses: 0,
        detail_count: 0,
        detail_expenses: 0,
        total_expenses: 0
      },
      rules: {
        company: [],
        r_date: [],
        r_user: [],
        document_count: [],
        amout: [],
        subject_matter: []
      },
      // 下拉框
      ComBoxItems: {
        company: []
      },
      // 展示金额
      showMoney: true,
      menuArgs: ''
    }
  },
  mounted() {
    this.id = this.$route.query.id

    this.BindText()

    this.menuArgs = this.$route.query.menuArgs
  },
  methods: {
    // 确认
    async sureConfirm(code) {
      if (code === 'refuse') {
        const success = await this.sureObsolete()
        if (success) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()
        }
      } else if (code === 'leaderReview') {
        const success = await this.sureReview()
        if (success) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()
        }
      } else if (code === 'unReview') {
        const success = await this.sureUnReview()
        if (success) {
          this.$message.success('取消成功!')

          this.$emit('updateData')
          this.BindText()
        }
      } else if (code === 'financialReview') {
        const success = await this.sureReview()
        if (success) {
          this.$message.success('操作成功')

          this.$emit('updateData')
          this.BindText()
        }
      }
    },
    // 拒绝
    refuse() {
      this.$refs.ConfirmModalRef.openDialog('refuse')
    },
    // 领导/总经理审批
    leaderReview() {
      this.$refs.ConfirmModalRef.openDialog('leaderReview')
    },
    // 财务审核通过
    async sureFinancialReview(flag) {
      const success = await this.sureReview(flag)
      if (success) {
        this.$message.success('操作成功')
        this.$refs.FinancialReviewModalVueRef.formVisible = false

        this.$emit('updateData')
        this.BindText()
      }
    },
    // 取消审核
    unReview() {
      this.$refs.ConfirmModalRef.openDialog('unReview')
    },
    // 调用审批接口
    async sureReview(flag = false) {
      const { data: res } = await this.$http.put('/finance/travel_expenses_form/audit', [
        {
          id: this.id,
          manager_review: flag
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 调用撤销审核
    async sureUnReview(flag = false) {
      const { data: res } = await this.$http.put('/finance/travel_expenses_form/unaudit', [
        {
          id: this.id,
          manager_review: flag
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 调用拒绝接口
    async sureObsolete() {
      const { data: res } = await this.$http.put('/finance/travel_expenses_form/obsolete', [
        {
          id: this.id,
          manager_review: false
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 点击底部按钮
    handleClickBtn(code) {
      switch (code) {
        case 'save':
          this.save()
          break
        case 'del':
          this.del()
          break
        case 'financialReview':
          // this.$refs.FinancialReviewModalVueRef.formVisible = true

          this.$refs.ConfirmModalRef.openDialog('financialReview')
          break
        case 'unReview':
          this.unReview()
          break
        case 'managerReview':
        case 'leaderReview':
          this.leaderReview()
          break
        case 'refuse':
          this.refuse()
          break
        case 'close':
          this.formVisible = false
          break
      }
    },
    // 绑定数据
    async BindText() {
      const that = this
      const { data: res } = await that.$http.get('/finance/travel_expenses_form/both', {
        params: {
          id: that.id
        }
      })
      if (res.isSuccess) {
        that.form = res.data
      }

      this.$nextTick(() => {
        if (this.$refs.EvectionPrintRef) {
          this.$refs.EvectionPrintRef.handlePrint()
        }
      })
    },
    // 点击附件按钮
    clickFileBtn() {
      this.$refs.PageDetailFileRef.openDialog()
    },
    showModal() {},
    // 大写金额转换
    convertCurrency(amount) {
      if (amount == null || amount == '') {
        return ''
      }
      return this.amountLtoU(amount)
    },
    // 选择人员
    handleSelect() {},
    // 主表选择框值改变为空时
    clearFormToNull(type) {
      switch (type) {
        case '':
          break
      }
    }
  }
}
</script>
<style lang="less" scoped>
@headerHeight: 50px;

// 没有明细数据时的展示
.no-detail-data {
  height: 80px;
  color: #bbbbbb;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bottom-detail {
  // 明细表
  .detail {
    display: flex;
    flex-wrap: wrap;
    padding: 10px;
    padding-bottom: 0;
    border-bottom: 1px solid #d4d5d7;
    margin-bottom: 10px;
    position: relative;

    .db-detail-item {
      width: 40% !important;
    }

    .detail-item {
      margin: 5px;
      width: 80%;
      font-size: 18px;

      > span {
        color: #888888;
      }
    }
  }
}

.app_detail_container {
  width: 100vw;
  height: 100vh;

  .app_menu_main {
    height: calc(100% - @headerHeight);
    width: 100%;
    // background-color: #fafafa;

    overflow: auto;

    box-sizing: border-box;
    // padding: 0 20px;
    // padding-top: 10px;
    // padding-bottom: 20px;

    /deep/ .el-form-item__label {
      padding: 0 !important;
      font-size: 20px !important;
      font-weight: 500;
      color: #a78897;
    }
    /deep/ .el-input__inner {
      border: 0 !important;
      border-bottom: 1px solid #d1d1d1 !important;
      border-radius: 0;
      padding-left: 0 !important;
      transition: all 0.3s;
      // background-color: #fafafa;
      font-size: 18px !important;
    }

    /deep/ .el-textarea__inner {
      font-size: 18px !important;
    }

    // /deep/ .el-input__inner:hover {
    //   padding-left: 10px !important;
    //   transition: all 0.3s;
    // }
    /deep/ .el-input__inner:focus {
      padding-left: 10px !important;
      transition: all 0.3s;
    }

    .app_menu_main_form {
      box-sizing: border-box;
      padding: 0 20px 20px 20px;
    }
  }
}
.file-list-container {
  // box-sizing: border-box;
  padding: 10px;

  height: 30px;
}
</style>
